// Contenu central du site — Le Bon Dépanneur (dépannage 24/7)
export const COMPANY = {
  name: "Le Bon Dépanneur",
  short: "LBD",
  tagline: "Dépannage d'urgence 24/7",
  phone: "09 72 64 44 40",
  phoneHref: "tel:+33972644440",
  whatsapp: "33766505505",
  email: "contact@lebondepanneur.fr",
  zone: "Paris & Île-de-France",
  hours: "24h/24 — 7j/7 — Jours fériés inclus",
};

// Visuels de marque "Le Bon Dépanneur" (photo camion fournie + set généré)
export const HERO_IMAGE = "/images/hero.jpg";
export const TRUST_WORKER = "/images/plomberie.jpg";
export const ABOUT_IMAGE = "/images/hero.jpg";

export const SERVICES = [
  {
    slug: "plomberie",
    index: "01",
    title: "Plomberie",
    short: "Fuites, dégâts des eaux, débouchage, chauffe-eau et robinetterie.",
    image: "/images/plomberie.jpg",
    seoDescription:
      "Plombier d'urgence à Paris et en Île-de-France, disponible 24h/24. Recherche de fuite, débouchage, dégât des eaux, chauffe-eau. Intervention en 30 min, devis clair.",
    intro:
      "Une fuite ne prévient jamais. Nos plombiers interviennent en urgence pour stopper les dégâts et rétablir votre installation en un temps record.",
    description: [
      "Un dégât des eaux peut causer des centaines d'euros de dommages en quelques heures seulement. C'est pourquoi Le Bon Dépanneur mobilise des plombiers professionnels 24h/24, prêts à couper l'arrivée d'eau, localiser l'origine du problème et effectuer la réparation dans la foulée.",
      "Qu'il s'agisse d'une simple fuite de robinet, d'une canalisation bouchée, d'un chauffe-eau en panne ou d'une inondation, nos artisans arrivent équipés du matériel nécessaire pour résoudre la majorité des interventions en une seule visite, sans vous imposer de retour.",
    ],
    tasks: [
      "Recherche & réparation de fuite",
      "Débouchage canalisation & WC",
      "Fuite chauffe-eau / ballon d'eau chaude",
      "Dégât des eaux & assèchement",
      "Remplacement robinetterie & flexibles",
      "Rupture ou gel de canalisation",
    ],
    signs: [
      "Traces d'humidité ou moisissures sur un mur",
      "Facture d'eau anormalement élevée",
      "Écoulement lent ou remontées d'odeurs",
      "Pas d'eau chaude ou pression en chute",
    ],
    price: "Dès 89€",
  },
  {
    slug: "serrurerie",
    index: "02",
    title: "Serrurerie",
    short: "Ouverture de porte, clé cassée, changement de serrure et blindage.",
    image: "/images/serrurerie.jpg",
    seoDescription:
      "Serrurier d'urgence à Paris et en Île-de-France 24h/24. Ouverture de porte claquée sans dégât, changement de serrure, blindage après effraction. Intervention rapide.",
    intro:
      "Porte claquée ou effraction ? Nous ouvrons sans dégât dans la majorité des cas et sécurisons immédiatement votre domicile.",
    description: [
      "Se retrouver bloqué devant sa porte, de jour comme de nuit, est une situation stressante. Nos serruriers sont formés aux techniques d'ouverture fine qui permettent, dans la grande majorité des cas de portes claquées, d'ouvrir sans aucun dégât ni changement de serrure.",
      "En cas de tentative d'effraction ou de cambriolage, nous intervenons en priorité pour sécuriser votre logement : remplacement du cylindre, pose d'une serrure certifiée A2P, blindage de porte et conseils de prévention pour éviter que cela se reproduise.",
    ],
    tasks: [
      "Ouverture de porte claquée sans dégât",
      "Extraction de clé cassée dans la serrure",
      "Changement de cylindre / serrure",
      "Pose de verrou et serrure multipoints",
      "Blindage & sécurisation après effraction",
      "Dépannage de rideau métallique",
    ],
    signs: [
      "Porte claquée avec les clés à l'intérieur",
      "Clé cassée ou bloquée dans le barillet",
      "Serrure qui force ou tourne dans le vide",
      "Effraction ou tentative de cambriolage",
    ],
    price: "Dès 79€",
  },
  {
    slug: "electricite",
    index: "03",
    title: "Électricité",
    short: "Panne de courant, court-circuit, tableau et mise aux normes.",
    image: "/images/electricite.jpg",
    seoDescription:
      "Électricien d'urgence à Paris et en Île-de-France 24h/24. Panne de courant, court-circuit, tableau électrique, mise aux normes NF C 15-100. Diagnostic sécurisé.",
    intro:
      "Une panne électrique peut être dangereuse. Nos électriciens diagnostiquent et sécurisent votre installation, de jour comme de nuit.",
    description: [
      "Une coupure de courant, un disjoncteur qui saute sans arrêt ou une odeur de brûlé au niveau d'une prise ne doivent jamais être pris à la légère : ce sont des signaux d'alerte. Nos électriciens certifiés réalisent un diagnostic complet pour identifier la cause exacte et écarter tout risque d'incendie ou d'électrocution.",
      "Nous remettons votre installation en service rapidement et, si nécessaire, procédons à sa mise aux normes NF C 15-100. Chaque intervention est réalisée dans le respect des règles de sécurité, avec un devis transparent communiqué avant tout travaux.",
    ],
    tasks: [
      "Panne de courant totale ou partielle",
      "Court-circuit & disjonction répétée",
      "Réparation de tableau électrique",
      "Mise aux normes NF C 15-100",
      "Recherche de surtension & faux contact",
      "Remplacement de prises & interrupteurs",
    ],
    signs: [
      "Disjoncteur qui saute régulièrement",
      "Prise ou interrupteur qui chauffe",
      "Odeur de brûlé ou grésillement",
      "Coupure totale sans raison apparente",
    ],
    price: "Dès 95€",
  },
];

export const STEPS = [
  { n: "01", title: "Vous appelez", text: "Un conseiller qualifié décroche en moins de 2 minutes, à toute heure du jour et de la nuit, et évalue votre urgence." },
  { n: "02", title: "Devis clair", text: "Diagnostic et tarif vous sont annoncés avant toute intervention. Vous validez, et il n'y a aucune surprise sur la facture." },
  { n: "03", title: "Intervention", text: "Un artisan proche de chez vous se déplace sous 30 minutes en moyenne, équipé pour résoudre la panne immédiatement." },
  { n: "04", title: "Garantie & suivi", text: "Travail garanti, facture détaillée remise sur place et suivi après intervention pour votre tranquillité." },
];

export const STATS = [
  { value: "30 min", label: "Délai moyen d'intervention" },
  { value: "24/7", label: "Disponibilité totale" },
  { value: "12 000+", label: "Interventions réalisées" },
  { value: "4.9/5", label: "Satisfaction client" },
];

export const MANIFESTO = [
  {
    n: "01",
    title: "L'urgence sans le stress",
    text: "Un sinistre est déjà assez éprouvant. Nous prenons tout en charge, de l'appel à la remise en état, pour que vous n'ayez rien à gérer et retrouviez rapidement votre quotidien.",
  },
  {
    n: "02",
    title: "Des prix annoncés à l'avance",
    text: "Devis transparent communiqué avant chaque intervention. Pas de frais cachés, pas de majoration surprise : vous savez exactement ce que vous payez, et pourquoi.",
  },
  {
    n: "03",
    title: "Des artisans certifiés",
    text: "Plombiers, serruriers et électriciens diplômés, assurés et régulièrement contrôlés. Un vrai savoir-faire, un matériel professionnel, aucun bricolage improvisé.",
  },
  {
    n: "04",
    title: "Partout, tout le temps",
    text: "Paris et toute l'Île-de-France, 24h/24 et 7j/7, week-ends et jours fériés compris. Où que vous soyez, une équipe n'est jamais loin de chez vous.",
  },
];

export const FAQ = [
  {
    q: "En combien de temps intervenez-vous ?",
    a: "Notre délai moyen d'intervention est de 30 minutes en Île-de-France. Pour les urgences critiques (inondation, effraction, coupure totale de courant), nous priorisons systématiquement votre demande et mobilisons l'artisan le plus proche de chez vous.",
  },
  {
    q: "Vos tarifs sont-ils annoncés avant l'intervention ?",
    a: "Oui, systématiquement. Un devis clair et détaillé vous est communiqué avant toute intervention. Vous ne payez que ce qui a été validé au préalable, sans frais cachés ni majoration de dernière minute.",
  },
  {
    q: "Intervenez-vous la nuit, le week-end et les jours fériés ?",
    a: "Absolument. Nous sommes disponibles 24h/24 et 7j/7, y compris la nuit, les week-ends et les jours fériés, avec le même niveau de sérieux et de professionnalisme qu'en journée.",
  },
  {
    q: "Ouvrez-vous les portes sans les casser ?",
    a: "Dans la très grande majorité des cas (portes simplement claquées), nos serruriers ouvrent sans aucun dégât grâce à des techniques professionnelles. Le perçage ou le remplacement de serrure ne sont utilisés qu'en dernier recours, sur les serrures verrouillées ou endommagées.",
  },
  {
    q: "Vos interventions sont-elles garanties ?",
    a: "Oui. Toutes nos interventions et les pièces que nous installons sont garanties. Vous recevez une facture détaillée et bénéficiez d'un suivi après intervention en cas de besoin.",
  },
  {
    q: "Quels moyens de paiement acceptez-vous ?",
    a: "Nous acceptons la carte bancaire, les espèces et les virements. Le règlement s'effectue une fois l'intervention terminée et le bon fonctionnement vérifié avec vous.",
  },
  {
    q: "Quelles zones géographiques couvrez-vous ?",
    a: "Nous couvrons Paris intra-muros et l'ensemble de l'Île-de-France : 75, 77 (Seine-et-Marne), 78 (Yvelines), 91 (Essonne), 92 (Hauts-de-Seine), 93 (Seine-Saint-Denis), 94 (Val-de-Marne) et 95 (Val-d'Oise).",
  },
  {
    q: "Que faire en attendant votre arrivée ?",
    a: "Pour une fuite d'eau, coupez l'arrivée d'eau générale. Pour un problème électrique, coupez le disjoncteur principal si vous le pouvez sans risque. Notre conseiller vous guide au téléphone dès votre appel pour sécuriser la situation.",
  },
];

export const GALLERY = [
  { src: "/images/plomberie.jpg", label: "Réparation de plomberie" },
  { src: "/images/serrurerie.jpg", label: "Ouverture & serrure" },
  { src: "/images/electricite.jpg", label: "Tableau électrique" },
  { src: "/images/g_faucet.jpg", label: "Dépannage robinetterie" },
  { src: "/images/g_panel.jpg", label: "Mise aux normes" },
  { src: "/images/g_multimeter.jpg", label: "Diagnostic & mesures" },
  { src: "/images/g_tools.jpg", label: "Équipement professionnel" },
  { src: "/images/hero.jpg", label: "Nos équipes mobiles" },
];

export const TESTIMONIALS = [
  { name: "Sophie M.", city: "Paris 11e", text: "Fuite en pleine nuit, technicien chez moi en 25 minutes. Rapide, propre, et le prix annoncé au téléphone a été respecté à l'euro près.", service: "Plomberie" },
  { name: "Karim B.", city: "Boulogne", text: "Porte claquée avec le bébé à l'intérieur. Le serrurier a ouvert sans aucun dégât en un temps record. Un immense soulagement, merci !", service: "Serrurerie" },
  { name: "Élodie R.", city: "Montreuil", text: "Panne totale un dimanche soir. Diagnostic clair, tableau réparé et mis aux normes. Très professionnel et rassurant du début à la fin.", service: "Électricité" },
];

export const TRUST_POINTS = [
  "Intervention en 30 min",
  "Devis gratuit & sans surprise",
  "Artisans certifiés & assurés",
  "Disponible 24h/24, 7j/7",
];

export const GUARANTEES = [
  { icon: "ShieldCheck", title: "Artisans assurés & certifiés", text: "Chaque intervenant est diplômé, déclaré et couvert par une assurance responsabilité civile et décennale." },
  { icon: "Receipt", title: "Devis gratuit et transparent", text: "Le prix vous est annoncé avant l'intervention. Vous validez en connaissance de cause, sans frais caché." },
  { icon: "Timer", title: "Rapidité garantie", text: "Un artisan mobilisé près de chez vous, sur place en 30 minutes en moyenne, 24h/24 et 7j/7." },
  { icon: "BadgeCheck", title: "Travail garanti", text: "Pièces et main-d'œuvre garanties, facture détaillée remise sur place et suivi après intervention." },
  { icon: "MapPin", title: "Des artisans locaux", text: "Un réseau de professionnels de proximité dans toute l'Île-de-France, pour des délais toujours plus courts." },
  { icon: "CreditCard", title: "Paiement sécurisé", text: "Réglez après l'intervention, une fois le bon fonctionnement vérifié : carte, espèces ou virement." },
];

// Contenu éditorial / SEO
export const ABOUT = {
  overline: "Qui sommes-nous",
  title: "Votre dépanneur de confiance en Île-de-France",
  paragraphs: [
    "Le Bon Dépanneur est un réseau d'artisans indépendants spécialisés dans le dépannage d'urgence en plomberie, serrurerie et électricité. Depuis plus de dix ans, nous accompagnons les particuliers, les syndics et les professionnels de Paris et de sa région lorsqu'un imprévu vient bouleverser leur quotidien.",
    "Notre promesse est simple : une intervention rapide, un diagnostic honnête et un tarif annoncé à l'avance. Nous savons qu'une urgence est une source de stress et parfois de dépenses inattendues ; c'est pourquoi nous mettons un point d'honneur à la transparence et au travail bien fait, du premier appel jusqu'au suivi après intervention.",
    "Chaque artisan de notre réseau est diplômé, assuré et sélectionné avec soin. Nous privilégions les techniciens locaux, proches de chez vous, pour garantir des délais courts et un service à taille humaine.",
  ],
};

export const ZONES = [
  "Paris (75)",
  "Seine-et-Marne (77)",
  "Yvelines (78)",
  "Essonne (91)",
  "Hauts-de-Seine (92)",
  "Seine-Saint-Denis (93)",
  "Val-de-Marne (94)",
  "Val-d'Oise (95)",
];
